import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, Description as DescriptionIcon } from '@mui/icons-material';
import { colors, fonts, spacing, borderRadius } from '../../../constants';
import { formatFileSize } from '../../../utils/fileUtils';
import { fileInfoBoxStyles, ICON_SIZES } from '../../../constants/importDialog';

/**
 * SelectedFileDisplay Component
 * Displays selected file information with remove button
 */
const SelectedFileDisplay = ({ file, onRemove }) => {
  if (!file) return null;

  return (
    <Box sx={fileInfoBoxStyles}>
      <DescriptionIcon sx={{ fontSize: ICON_SIZES.FILE_ICON, color: colors.primary }} />
      <Box sx={{ flex: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: fonts.weightMedium,
            color: colors.textPrimaryDark,
            fontSize: fonts.fontSizeSm,
          }}
        >
          {file.name}
        </Typography>
        <Typography
          variant="caption"
          sx={{
            color: colors.textSecondary,
            fontSize: fonts.fontSizeXs,
          }}
        >
          {formatFileSize(file.size)}
        </Typography>
      </Box>
      <IconButton
        size="small"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        sx={{
          color: colors.textSecondary,
          '&:hover': {
            backgroundColor: colors.background,
            color: colors.error,
          },
        }}
      >
        <CloseIcon sx={{ fontSize: ICON_SIZES.STATUS_ICON }} />
      </IconButton>
    </Box>
  );
};

export default SelectedFileDisplay;
